import { createApp } from "vue";
import App from "./App.vue";

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router";
import store from "./store";

//imports for app initialization
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";

import "@/core/plugins/keenthemes";
import "@/core/plugins/prismjs";
import "bootstrap";
import { loadTranslations } from "./core/helpers/translator";

import { VueReCaptcha } from 'vue-recaptcha-v3'

loadTranslations().then(() => {
    const app = createApp(App);

    app.use(store);
    app.use(router);

    app.use(VueReCaptcha, {
        siteKey: process.env.VUE_APP_RECAPTCHA_KEY,
        loaderOptions: {
            useRecaptchaNet: true,
            autoHideBadge: true
        }
    });

    initApexCharts(app);
    initInlineSvg(app);
    initVeeValidate();
    app.mount("#app")
});